import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
const DateRangePicker = ({ value, allowClear = true, disabled = false, onChange }) => {
    const tomorrow6am = dayjs().add(1, 'days').hour(6).minute(0);
    const tomorrow7am = dayjs().add(1, 'days').hour(7).minute(0);
    const tomorrow9am = dayjs().add(1, 'days').hour(9).minute(0);
    const tomorrow10am = dayjs().add(1, 'days').hour(10).minute(0);
    const tomorrow12pm = dayjs().add(1, 'days').hour(12).minute(0);
    const tomorrow1pm = dayjs().add(1, 'days').hour(13).minute(0);
    const tomorrow3pm = dayjs().add(1, 'days').hour(15).minute(0);
    const tomorrow4pm = dayjs().add(1, 'days').hour(16).minute(0);
    const tomorrow5pm = dayjs().add(1, 'days').hour(17).minute(0);
    const tomorrow6pm = dayjs().add(1, 'days').hour(18).minute(0);
    return (_jsx(DatePicker.RangePicker, { presets: [
            { label: 'Today', value: [dayjs().hour(8).minute(0), dayjs().hour(17).minute(0)] },
            { label: 'Tomorrow 6am - 9am', value: [tomorrow6am, tomorrow9am] },
            { label: 'Tomorrow 7am - 10am', value: [tomorrow7am, tomorrow10am] },
            { label: 'Tomorrow 9am - 12pm', value: [tomorrow9am, tomorrow12pm] },
            { label: 'Tomorrow 10am - 1pm', value: [tomorrow10am, tomorrow1pm] },
            { label: 'Tomorrow 12pm - 3pm', value: [tomorrow12pm, tomorrow3pm] },
            { label: 'Tomorrow 1pm - 4pm', value: [tomorrow1pm, tomorrow4pm] },
            { label: 'Tomorrow 3pm - 6pm', value: [tomorrow3pm, tomorrow6pm] },
            { label: 'Tomorrow 6am - 6pm', value: [tomorrow6am, tomorrow6pm] },
            { label: 'Tomorrow 9am - 5pm', value: [tomorrow9am, tomorrow5pm] },
        ], value: value, allowClear: allowClear, disabled: disabled, showTime: true, format: "DD/MM/YYYY HH:mm", placeholder: ['Start Time', 'End Time'], onChange: onChange, minuteStep: 5, style: {
            width: "100%"
        } }));
};
export default DateRangePicker;
